<div class="np-form-control dx-fieldset">
  <dx-box direction="row" width="100%" [ngStyle]="{ gap: '2rem', marginBottom: '2rem' }">
    <dxi-item [ratio]="1">
      <div class="dx-card">
        <div class="dx-fieldset">

          <div class="dx-fieldset-header">{{ 'Artikelinformationen' | translate }}</div>

          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Neu' | translate }}"
                             [field]="fieldNames.scireumIsNew"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <np-booleanRadioGroup [(value)]="model.scireum.isNew"
                                      [templateView]="templateView"
                                      [readOnly]="readOnly(fieldNames.scireumIsNew)"
                                      [fieldName]="validationService.fieldNames.scireumIsNew"
                                      [showNullValue]="false"
                                      (onValueChanged)="update($event, fieldNames.scireumIsNew)"
                                      validatorValidationGroup="SCIREUM" />
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Aktion' | translate }}"
                             [field]="fieldNames.scireumSale"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <np-booleanRadioGroup [(value)]="model.scireum.sale"
                                      [templateView]="templateView"
                                      [readOnly]="readOnly(fieldNames.scireumSale)"
                                      [fieldName]="validationService.fieldNames.scireumSale"
                                      [showNullValue]="false"
                                      (onValueChanged)="update($event, fieldNames.scireumSale)"
                                      validatorValidationGroup="SCIREUM" />
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Abverkauf' | translate }}"
                             [field]="fieldNames.scireumClearance"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <np-booleanRadioGroup [(value)]="model.scireum.clearance"
                                      [templateView]="templateView"
                                      [readOnly]="readOnly(fieldNames.scireumClearance)"
                                      [fieldName]="validationService.fieldNames.scireumClearance"
                                      [showNullValue]="false"
                                      (onValueChanged)="update($event, fieldNames.scireumClearance)"
                                      validatorValidationGroup="SCIREUM" />
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Nicht bestellbar' | translate }}"
                             [field]="fieldNames.scireumIsNotOrderable"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <np-booleanRadioGroup [(value)]="model.scireum.isNotOrderable"
                                      [templateView]="templateView"
                                      [readOnly]="readOnly(fieldNames.scireumIsNotOrderable)"
                                      [fieldName]="validationService.fieldNames.scireumIsNotOrderable"
                                      [showNullValue]="false"
                                      (onValueChanged)="update($event, fieldNames.scireumIsNotOrderable)"
                                      validatorValidationGroup="SCIREUM" />
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Versteckt' | translate }}"
                             [field]="fieldNames.scireumHidden"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <np-booleanRadioGroup [(value)]="model.scireum.hidden"
                                      [templateView]="templateView"
                                      [readOnly]="readOnly(fieldNames.scireumHidden)"
                                      [fieldName]="validationService.fieldNames.scireumHidden"
                                      [showNullValue]="false"
                                      (onValueChanged)="update($event, fieldNames.scireumHidden)"
                                      validatorValidationGroup="SCIREUM" />
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Lagerartikel' | translate }}"
                             [field]="fieldNames.scireumStockItem"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <np-booleanRadioGroup [(value)]="model.scireum.stockItem"
                                      [templateView]="templateView"
                                      [readOnly]="readOnly(fieldNames.scireumStockItem)"
                                      [fieldName]="validationService.fieldNames.scireumStockItem"
                                      [showNullValue]="false"
                                      (onValueChanged)="update($event, fieldNames.scireumStockItem)"
                                      validatorValidationGroup="SCIREUM" />
              </div>
            </np-inputControl>
          </div>
          <div class="np-field" *ngIf="loginService.hasAddonSellsite_Bormann">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Exportfähig' | translate }}"
                             [field]="fieldNames.scireumExportable"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <np-booleanRadioGroup [(value)]="model.scireum.exportable"
                                      [templateView]="templateView"
                                      [readOnly]="readOnly(fieldNames.scireumExportable)"
                                      [fieldName]="validationService.fieldNames.scireumExportable"
                                      [showNullValue]="false"
                                      (onValueChanged)="update($event, fieldNames.scireumExportable)"
                                      validatorValidationGroup="SCIREUM" />
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Fachhandelsbindung' | translate }}"
                             [field]="fieldNames.scireumSpecialistRetailer"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <np-booleanRadioGroup [(value)]="model.scireum.specialistRetailer"
                                      [templateView]="templateView"
                                      [readOnly]="readOnly(fieldNames.scireumSpecialistRetailer)"
                                      [fieldName]="validationService.fieldNames.scireumSpecialistRetailer"
                                      [showNullValue]="false"
                                      (onValueChanged)="update($event, fieldNames.scireumSpecialistRetailer)"
                                      validatorValidationGroup="SCIREUM" />
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Serie' | translate }}"
                             [field]="fieldNames.scireumSeries"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <dx-text-box [(value)]="model.scireum.series" (onValueChanged)="update($event, fieldNames.scireumSeries)">
                  <dx-validator validationGroup="SCIREUM"
                                (onInitialized)="validationService.startAutomaticValidation($event)">

                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumSeries)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </np-inputControl>
          </div>
          <div class="np-field" *ngIf="loginService.hasAddonSellsite_Bormann">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Zusätzlicher erweiterter Suchbegriff' | translate }}"
                             [field]="fieldNames.scireumExtendedKeyword"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <dx-text-box [(value)]="model.scireum.extendedKeyword"
                             (onValueChanged)="update($event, fieldNames.scireumExtendedKeyword)">
                  <dx-validator validationGroup="SCIREUM"
                                (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumExtendedKeyword)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </np-inputControl>
          </div>

          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Konfigurator URL' | translate }}"
                             [field]="fieldNames.scireumConfiguratorLink"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <dx-text-box [(value)]="model.scireum.configuratorLink"
                             (onValueChanged)="update($event, fieldNames.scireumConfiguratorLink)">
                  <dx-validator validationGroup="SCIREUM"
                                (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumConfiguratorLink)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </np-inputControl>
          </div>

          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Ranking' | translate }}"
                             [field]="fieldNames.scireumRanking"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <dx-number-box [(value)]="model.scireum.ranking"
                               [min]="0"
                               placeholder=""
                               (onValueChanged)="update($event, fieldNames.scireumRanking)"
                               [showSpinButtons]="true">
                  <dx-validator validationGroup="SCIREUM" (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumRanking)"></dxi-validation-rule>
                  </dx-validator>
                </dx-number-box>
              </div>
            </np-inputControl>
          </div>
        </div>

      </div>
    </dxi-item>


    <!-- Erweiterte Gefahrgutinformationen -->


    <dxi-item [ratio]="1">
      <div class="dx-card">
        <div class="dx-fieldset">
          <div class="dx-fieldset-header">{{ 'Erweiterte Gefahrgutinformationen' | translate }}</div>

          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Nur gewerblich' | translate }}"
                             [field]="fieldNames.scireumNurGewerblich"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <np-booleanRadioGroup [(value)]="model.scireum.nurGewerblich"
                                      [templateView]="templateView"
                                      [readOnly]="readOnly(fieldNames.scireumNurGewerblich)"
                                      [fieldName]="validationService.fieldNames.scireumNurGewerblich"
                                      [showNullValue]="false"
                                      (onValueChanged)="update($event,fieldNames.scireumNurGewerblich)"
                                      validatorValidationGroup="SCIREUM" />
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Enthält Lithiumbatterie?' | translate }}"
                             [field]="fieldNames.scireumLithiumbatterieEnthalten"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <np-booleanRadioGroup [(value)]="model.scireum.lithiumbatterieEnthalten"
                                      [templateView]="templateView"
                                      [readOnly]="readOnly(fieldNames.scireumLithiumbatterieEnthalten)"
                                      [fieldName]="validationService.fieldNames.scireumLithiumbatterieEnthalten"
                                      [showNullValue]="false"
                                      (onValueChanged)="update($event, fieldNames.scireumLithiumbatterieEnthalten)"
                                      validatorValidationGroup="SCIREUM" />
              </div>
            </np-inputControl>
          </div>


            <div class="np-field">

            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Enthält elektrische Komponenten' | translate }}"
                             [field]="fieldNames.scireumElektrischeKomponenten"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <np-booleanRadioGroup [(value)]="model.scireum.enthaeltElektrischeKomponenten"
                                      [templateView]="templateView"
                                      [readOnly]="readOnly(fieldNames.scireumElektrischeKomponenten)"
                                      [fieldName]="validationService.fieldNames.scireumElektrischeKomponenten"
                                      [showNullValue]="false"
                                      (onValueChanged)="update($event, fieldNames.scireumElektrischeKomponenten)"
                                      validatorValidationGroup="SCIREUM" />
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Hat CE-Kennzeichnung' | translate }}"
                             [field]="fieldNames.scireumCEKennzeichung"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <np-booleanRadioGroup [(value)]="model.scireum.ceKennzeichnung"
                                      [templateView]="templateView"
                                      [readOnly]="readOnly(fieldNames.scireumCEKennzeichung)"
                                      [fieldName]="validationService.fieldNames.scireumCEKennzeichung"
                                      [showNullValue]="false"
                                      (onValueChanged)="update($event, fieldNames.scireumCEKennzeichung)"
                                      validatorValidationGroup="SCIREUM" />
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'In ECHA DB hinterlegt' | translate }}"
                             [field]="fieldNames.scireumECHABDhinterlegt"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <np-booleanRadioGroup [(value)]="model.scireum.echadbhinterlegt"
                                      [templateView]="templateView"
                                      [readOnly]="readOnly(fieldNames.scireumECHABDhinterlegt)"
                                      [fieldName]="validationService.fieldNames.scireumECHABDhinterlegt"
                                      [showNullValue]="false"
                                      (onValueChanged)="update($event, fieldNames.scireumECHABDhinterlegt)"
                                      validatorValidationGroup="SCIREUM" />
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Erfüllt Anforderungen der UBA Positivliste' | translate }}"
                             [field]="fieldNames.scireumUBAListKonform"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <np-booleanRadioGroup [(value)]="model.scireum.ubaListKonform"
                                      [templateView]="templateView"
                                      [readOnly]="readOnly(fieldNames.scireumUBAListKonform)"
                                      [fieldName]="validationService.fieldNames.scireumUBAListKonform"
                                      [showNullValue]="false"
                                      (onValueChanged)="update($event, fieldNames.scireumUBAListKonform)"
                                      validatorValidationGroup="SCIREUM" />
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">

            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Gefahrgutklasse' | translate }}"
                             [field]="fieldNames.scireumGefahrengutklasse"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">

                <dx-autocomplete [minSearchLength]="0"
                                 [dataSource]="gefahrgutKlassenArray"
                                 [readOnly]="readOnlyForLinkedFields(fieldNames.scireumGefahrengutklasse)"
                                 [showClearButton]="showClearButton()"
                                 [showDropDownButton]="true"
                                 [(value)]="model.scireum.gefahrengutKlasse"
                                 (onValueChanged)="update($event, fieldNames.scireumGefahrengutklasse)">

                </dx-autocomplete>
              </div>
            </np-inputControl>
          </div>
            <div class="np-field">
                <np-inputControl [(model)]="model"
                                 [showLinkButtons]="true"
                                 [suppressPlaceLabel]="true"
                                 [(selectedElements)]="selectedElements"
                                 (elementSelected)="elementSelectFunction($event)"
                                 (onValueChanged)="update($event)"
                                 labelText="{{ 'Beförderungskategorie' | translate }}"
                                 [field]="fieldNames.scireumBefoerderungskategorie"
                                 [showDragHandle]="showDragHandle"
                                 [dragFilter]="dragFilter"
                                 (excelElementDropped)="excelElementDrop($event)">
                    <div slot="content" class="contentSlot">

                        <dx-autocomplete [minSearchLength]="0"
                                         [dataSource]="befoerderungskategorieArray"
                                         [readOnly]="readOnlyForLinkedFields(fieldNames.scireumBefoerderungskategorie)"
                                         [showClearButton]="showClearButton()"
                                         [showDropDownButton]="true"
                                         [(value)]="model.scireum.befoerderungskategorie"
                                         (onValueChanged)="update($event, fieldNames.scireumBefoerderungskategorie)">

                        </dx-autocomplete>
                    </div>
                </np-inputControl>
            </div>

            <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'UN-Nummer' | translate }}"
                             [field]="fieldNames.scireumUnNummer"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <dx-number-box [(value)]="model.scireum.unNummer"
                               [min]="0"
                               placeholder=""
                               (onValueChanged)="update($event, fieldNames.scireumUnNummer)">
                  <dx-validator validationGroup="SCIREUM" (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumUnNummer)"></dxi-validation-rule>
                  </dx-validator>
                </dx-number-box>

              </div>
            </np-inputControl>
          </div>
          <div class="np-field">

            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Offizielle Bezeichnung' | translate }}"
                             [field]="fieldNames.scireumOffizielleBezeichnung"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">

                <dx-text-box [(value)]="model.scireum.offizielleBezeichnung" (onValueChanged)="update($event, fieldNames.scireumOffizielleBezeichnung)">
                  <dx-validator validationGroup="SCIREUM"
                                (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumOffizielleBezeichnung)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </np-inputControl>
          </div>

          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Technische Bezeichnung' | translate }}"
                             [field]="fieldNames.scireumTechnischeBezeichnung"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">

                <dx-text-box [(value)]="model.scireum.technischeBezeichnung" (onValueChanged)="update($event, fieldNames.scireumTechnischeBezeichnung)">
                  <dx-validator validationGroup="SCIREUM"
                                (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumTechnischeBezeichnung)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Versandbezeichnung' | translate }}"
                             [field]="fieldNames.scireumVersandbezeichnung"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">

                <dx-text-box [(value)]="model.scireum.versandbezeichnung" (onValueChanged)="update($event, fieldNames.scireumVersandbezeichnung)">
                  <dx-validator validationGroup="SCIREUM"
                                (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumVersandbezeichnung)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Gefahrenzettel' | translate }}"
                             [field]="fieldNames.scireumGefahrenzettel"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">

                <dx-autocomplete [minSearchLength]="0"
                                 [dataSource]="gefahrenzettelArray"
                                 [readOnly]="readOnlyForLinkedFields(fieldNames.scireumGefahrenzettel)"
                                 [showClearButton]="showClearButton()"
                                 [showDropDownButton]="true"
                                 [(value)]="model.scireum.gefahrenzettel"
                                 (onValueChanged)="update($event, fieldNames.scireumGefahrenzettel)">

                </dx-autocomplete>
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Gefahrgut-Verpackungsgruppe' | translate }}"
                             [field]="fieldNames.scireumGefahrgutVerpackungsgruppe"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">

                <dx-autocomplete [minSearchLength]="0"
                                 [dataSource]="gefahrgutVerpackungsgruppeArray"
                                 [readOnly]="readOnlyForLinkedFields(fieldNames.scireumGefahrgutVerpackungsgruppe)"
                                 [showClearButton]="showClearButton()"
                                 [showDropDownButton]="true"
                                 [(value)]="model.scireum.gefahrgutVerpackungsgruppe"
                                 (onValueChanged)="update($event, fieldNames.scireumGefahrgutVerpackungsgruppe)">

                </dx-autocomplete>
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Anzahl der Gefahrgut-Versandstücke' | translate }}"
                             [field]="fieldNames.scireumAnzahlGefahrgutVersandstuecke"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <dx-number-box [(value)]="model.scireum.anzahlGefahrgutVersandstuecke"
                               [min]="0"
                               placeholder=""
                               (onValueChanged)="update($event, fieldNames.scireumAnzahlGefahrgutVersandstuecke)">
                  <dx-validator validationGroup="SCIREUM" (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumAnzahlGefahrgutVersandstuecke)"></dxi-validation-rule>
                  </dx-validator>
                </dx-number-box>

              </div>
            </np-inputControl>
          </div>

          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Beschreibung der Gefahrgut-Versandstücke' | translate }}"
                             [field]="fieldNames.scireumBeschreibungGefahrgutVerandstuecke"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">

                <dx-text-box [(value)]="model.scireum.beschreibungGefargutVersandstuecke" (onValueChanged)="update($event, fieldNames.scireumBeschreibungGefahrgutVerandstuecke)">
                  <dx-validator validationGroup="SCIREUM"
                                (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumBeschreibungGefahrgutVerandstuecke)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </np-inputControl>
          </div>

          <div class="np-field">

            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Batteriepiktogramm' | translate }}"
                             [field]="fieldNames.scireumBatteriepiktogramm"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">

                <dx-autocomplete [minSearchLength]="0"
                                 [dataSource]="batteriepiktogrammAray"
                                 [readOnly]="readOnlyForLinkedFields(fieldNames.scireumBatteriepiktogramm)"
                                 [showClearButton]="showClearButton()"
                                 [showDropDownButton]="true"
                                 [(value)]="model.scireum.batteriepiktogramm"
                                 (onValueChanged)="update($event, fieldNames.scireumBatteriepiktogramm)">

                </dx-autocomplete>
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Handelsname' | translate }}"
                             [field]="fieldNames.scireumHandelsname"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">

                <dx-text-box [(value)]="model.scireum.handelsname" (onValueChanged)="update($event, fieldNames.scireumHandelsname)">
                  <dx-validator validationGroup="SCIREUM"
                                (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumHandelsname)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </np-inputControl>
          </div>
        </div>
      </div>
    </dxi-item>




  </dx-box>



<!--Zusätzliche Logistikmaße & Einheiten -->

  <dx-box direction="row" width="100%" [ngStyle]="{ gap: '2rem', marginBottom: '2rem' }">
    <dxi-item [ratio]="1">
      <div class="dx-card">
        <div class="dx-fieldset">
          <div class="dx-fieldset-header">{{ 'Zusätzliche Logistikmaße & Einheiten' | translate }}</div>

          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Empfohlene Menge' | translate }}"
                             [field]="fieldNames.scireumEmpfohleneMenge"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <dx-number-box [(value)]="model.scireum.empfohleneMenge"
                               [min]="0"
                               placeholder=""
                               (onValueChanged)="update($event, fieldNames.scireumEmpfohleneMenge)"
                               [showSpinButtons]="true">
                  <dx-validator validationGroup="SCIREUM" (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumEmpfohleneMenge)"></dxi-validation-rule>
                  </dx-validator>
                </dx-number-box>
              </div>
            </np-inputControl>

          </div>

            <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Artikellänge in mm' | translate }}"
                             [field]="fieldNames.scireumArtikellaengeMM"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <dx-number-box [(value)]="model.scireum.artikellaengeMM"
                               [min]="0"
                               placeholder=""
                               (onValueChanged)="update($event, fieldNames.scireumArtikellaengeMM)">
                  <dx-validator validationGroup="SCIREUM" (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumArtikellaengeMM)"></dxi-validation-rule>
                  </dx-validator>
                </dx-number-box>
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Artikelbreite in mm' | translate }}"
                             [field]="fieldNames.scireumArtikelbreiteMM"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <dx-number-box [(value)]="model.scireum.artikelbreiteMM"
                               placeholder=""
                               (onValueChanged)="update($event, fieldNames.scireumArtikelbreiteMM)">
                  <dx-validator validationGroup="SCIREUM" (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumArtikelbreiteMM)"></dxi-validation-rule>
                  </dx-validator>
                </dx-number-box>
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Artikelhöhe in mm' | translate }}"
                             [field]="fieldNames.scireumArtikelhoeheMM"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <dx-number-box [(value)]="model.scireum.artikelhoeheMM"
                               [min]="0"
                               placeholder=""
                               (onValueChanged)="update($event, fieldNames.scireumArtikelhoeheMM)">
                  <dx-validator validationGroup="SCIREUM" (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumArtikelhoeheMM)"></dxi-validation-rule>
                  </dx-validator>
                </dx-number-box>
              </div>
            </np-inputControl>
          </div>

          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Artikeltiefe in mm' | translate }}"
                             [field]="fieldNames.scireumArtikeltiefeMM"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <dx-number-box [(value)]="model.scireum.artikeltiefeMM"
                               [min]="0"
                               placeholder=""
                               (onValueChanged)="update($event, fieldNames.scireumArtikeltiefeMM)">
                  <dx-validator validationGroup="SCIREUM" (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumArtikeltiefeMM)"></dxi-validation-rule>
                  </dx-validator>
                </dx-number-box>
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">

            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Artikelgewicht in kg' | translate }}"
                             [field]="fieldNames.scireumArtikelGewichtKG"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <dx-number-box [(value)]="model.scireum.artikelGewichtKG"
                               [min]="0"
                               placeholder=""
                               (onValueChanged)="update($event, fieldNames.scireumArtikelGewichtKG)">
                  <dx-validator validationGroup="SCIREUM" (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumArtikelGewichtKG)"></dxi-validation-rule>
                  </dx-validator>
                </dx-number-box>
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Volumen' | translate }}"
                             [field]="fieldNames.scireumVolumen"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <dx-number-box [(value)]="model.scireum.volumen"
                               [min]="0"
                               placeholder=""
                               (onValueChanged)="update($event, fieldNames.scireumVolumen)">
                  <dx-validator validationGroup="SCIREUM" (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumVolumen)"></dxi-validation-rule>
                  </dx-validator>
                </dx-number-box>
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Warennummer' | translate }}"
                             [field]="fieldNames.scireumWarennummer"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <dx-text-box [(value)]="model.scireum.warennummer"
                             placeholder=""
                             (onValueChanged)="update($event, fieldNames.scireumWarennummer)">
                  <dx-validator validationGroup="SCIREUM" (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumWarennummer)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </np-inputControl>
          </div>
        </div>
      </div>
    </dxi-item>

    <!-- Zusätzliche Aritkelnummern-->
    <dxi-item [ratio]="1">
      <div class="dx-card">
        <div class="dx-fieldset">
          <div class="dx-fieldset-header">{{ 'Zusätzliche Artikelnummern' | translate }}</div>

          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'OXOMI Hausmarkennummer' | translate }}"
                             [field]="fieldNames.scireumOxomiHausmarkennummer2"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <dx-text-box [(value)]="model.scireum.oxomiHausmarkennummer" (onValueChanged)="update($event, fieldNames.scireumOxomiHausmarkennummer2)">
                  <dx-validator validationGroup="SCIREUM"
                                (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumOxomiHausmarkennummer2)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </np-inputControl>
          </div>

          <div class="np-field" *ngIf="loginService.hasAddonSellsite_Bormann" >
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Nordwest-Artikelnummer' | translate }}"
                             [field]="fieldNames.scireumNordwestArtikelnummer"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <dx-text-box [(value)]="model.scireum.nordwestArtikelnummer"
                             (onValueChanged)="update($event, fieldNames.scireumNordwestArtikelnummer)">
                  <dx-validator validationGroup="SCIREUM"
                                (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumNordwestArtikelnummer)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Abweichende Lieferantennummer' | translate }}"
                             [field]="fieldNames.scireumAbweichendeLieferantennummer"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <dx-text-box [(value)]="model.scireum.abweichendeLieferantennummer"
                             (onValueChanged)="update($event, fieldNames.scireumAbweichendeLieferantennummer)">
                  <dx-validator validationGroup="SCIREUM"
                                (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumAbweichendeLieferantennummer)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </np-inputControl>
          </div>

          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Zusätzlicher Match-Code' | translate }}"
                             [field]="fieldNames.scireumZusaetzlicherMatchCode"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <dx-text-box [(value)]="model.scireum.zusaetzlicherMatchCode"
                             (onValueChanged)="update($event, fieldNames.scireumZusaetzlicherMatchCode)">
                  <dx-validator validationGroup="SCIREUM"
                                (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumZusaetzlicherMatchCode)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </np-inputControl>
          </div>
          <div class="np-field">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="true"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Katalogartikelnummer' | translate }}"
                             [field]="fieldNames.scireumKatalogartikelnummer"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot">
                <dx-text-box [(value)]="model.scireum.katalogartikelnummer"
                             (onValueChanged)="update($event, fieldNames.scireumKatalogartikelnummer)">
                  <dx-validator validationGroup="SCIREUM"
                                (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField(fieldNames.scireumKatalogartikelnummer)"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </np-inputControl>
          </div>
        </div>

      </div>

    </dxi-item>
  
  </dx-box>
</div>
